<template>
    <div class="wrapper">
        <div class="inner">
            <p>{{ $t('chat.upgradePopup') }}</p>
            <div class="buttons-wrapper">
                <ion-button class="send-button ion-float-start" @click="goToPlans">{{ $t('chat.subscribe') }}</ion-button>
                <ion-button class="cancel-button ion-float-end" @click="handleCancel">{{ $t('master.cancel') }}</ion-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlansPopup',
    methods: {
        goToPlans() {
            this.$router.push('/plans')
        },
        handleCancel() {
            this.$emit('cancel')
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 100%;
    height: 100%;
    top: 5.5%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 11;

    .inner {
        background-color: #7cc18b;
        width: 80%;
        z-index: 9;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 4%;
        border-radius: 10px;
    }
}

@media (min-width: 1200px) {
    .wrapper {
        .inner {
            width: 30%;
        }
    }
}
</style>
